export default {
      id: "logo_2-usage",
      viewBox: "0 0 155 155",
      url: __webpack_public_path__ + "img/icons.14f187a1.svg#logo_2",
      toString: function () {
        return this.url;
      }
    }